import { ReactNode } from "react";

export const ConditionBox = ({ children }: { children: ReactNode }) => (
  <ul className="flex h-fit max-h-[15rem] w-full flex-col gap-y-4 overflow-y-auto rounded-[0.75rem] border border-ciety-dk-60 p-5">
    {children}
  </ul>
);
